export default __webpack_public_path__ + "static/media/magnet-icon.bee73745.svg";